import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleRoutingModule } from './article-routing.module';
import ArticleSidenavConfig from './articleSidenavConfig';
import { SideNavService } from 'src/app/shared/layouts/side-nav/services/side-nav.service';
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * NOTE THAT THIS MODULE WILL BE LOADED IN THE APP.
 * DO NOT IMPORT ANYTHING IN HERE.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

@NgModule({
  declarations: [],
  imports: [CommonModule, ArticleRoutingModule],
  exports: [],
  providers: [],
})
export class ArticleModule {
  constructor(private sideNavService: SideNavService) {
    /**
     * CODE IN HERE WILL BE EXECUTED ON APP LOAD.
     * USE IT TO INJECT YOUR SUB APP INTO THE MAIN APPLICATION
     */
    this.sideNavService.addSubMenuItems(
      'news',
      ArticleSidenavConfig.articleLinks
    );
    this.sideNavService.addSubMenuItems(
      'setting',
      ArticleSidenavConfig.articleSettingsLinks
    );
  }
}
